import { render } from "./ReturnPortMap.vue?vue&type=template&id=48f1470e&scoped=true"
import script from "./ReturnPortMap.vue?vue&type=script&lang=js"
export * from "./ReturnPortMap.vue?vue&type=script&lang=js"

import "./ReturnPortMap.vue?vue&type=style&index=0&id=48f1470e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f1470e"]])

export default __exports__